import arMessages from './messages/ar.json';

const messages = {
  ar: arMessages,
};

export default messages;
